export default __webpack_public_path__ + "static/media/van-ambulance.ca0610c0.svg";